module.exports = require("./mni");